// Underscores in values for backward compatibility with Sensible configurations
export enum PdfParsingSupportedEHR {
    therapyNotes = "therapy_notes",
    simplePractice = "simple_practice",
    // TODO: uncomment when we'll support TheraNest for pre-configured parsing
    // theraNest = "thera_nest",
}
